import { Badge, createStyles, makeStyles, Theme, withStyles } from "@material-ui/core";
import { COLORS } from "constants/colors";

export const useDrawerStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      right: 0,
      position: "absolute",
      top: 64
     },
    buttonDrawer: {
      display: "none",
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        backgroundColor: COLORS.primary,
        boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.25)",
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        color: "#fff",
        padding: 11,
        height: 98,
        width: 36,
        transform: "rotate(180deg)",
        writingMode: "vertical-lr",
      },
    },
    rootDrawer: {
      background: "inherit",

      width: "90%",
      "& .MuiDrawer-paperAnchorRight": {
        width: "100%",
      },
    },
    rootBadge: {
      display: "flex",
      marginLeft: -7,
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    rootBadgeNone: {
      display: "flex",
      marginBottom: -3,
      "& > *": {
        margin: theme.spacing(1),
      },
    },
    drawerStyle: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        boxShadow: "0",
        "& .MuiBackdrop-root": {
          backgroundColor: "inherit",
        },
        "& .MuiDrawer-paperAnchorRight": {
          left: "1px",
        },
      },
    },
    icon: {
      [theme.breakpoints.down("xs")]: {
        marginLeft: 210,
      },
    },
    iconStyle: { width: 13, height: 13, color: "#757a93" },
    textStyle: {
      marginLeft: 4,
      writingMode: "vertical-lr",
    },
    title: {
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        justifyContent: "space-between",
        height: 31.4,
        margin: "15px 10px 10px 15px",
        fontFamily: "Montserrat",
        fontSize: 16,
        fontWeight: "bold",
        textAlign: "left",
        color: "#757a93",
      },
    },
  })
);

export const StyledBadge = withStyles((theme: Theme) =>
  createStyles({
    badge: {
      backgroundColor: "#44b700",
      color: "#44b700",
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "$ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""',
      },
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1,
      },
      "100%": {
        transform: "scale(2.4)",
        opacity: 0,
      },
    },
  })
)(Badge);
